import * as React from "react";
import type { SVGProps } from "react";
const SvgCrossSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#cross-small_svg__a)">
      <path d="M14.66 15.66a1 1 0 0 1-.71-.29L8.29 9.71a1.004 1.004 0 0 1 1.42-1.42l5.66 5.66a.999.999 0 0 1-.71 1.71" />
      <path d="M9 15.66a1 1 0 0 1-.71-1.71l5.66-5.66a1.004 1.004 0 0 1 1.42 1.42l-5.66 5.66a1 1 0 0 1-.71.29" />
    </g>
    <defs>
      <clipPath id="cross-small_svg__a">
        <path fill="#fff" d="M8 8h7.66v7.66H8z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCrossSmall;
